module.exports = __webpack_public_path__ + "img/webinars_2_375.e81840c.jpg";